import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";

function createMCQ(_x) {
  return _createMCQ.apply(this, arguments);
}

function _createMCQ() {
  _createMCQ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref) {
    var courseTemplateId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            courseTemplateId = _ref.courseTemplateId, data = _ref.data, onUploadProgress = _ref.onUploadProgress;
            _context5.next = 3;
            return http.post("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/questions/mcqs"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _createMCQ.apply(this, arguments);
}

function createTF(_x2) {
  return _createTF.apply(this, arguments);
}

function _createTF() {
  _createTF = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref2) {
    var courseTemplateId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            courseTemplateId = _ref2.courseTemplateId, data = _ref2.data, onUploadProgress = _ref2.onUploadProgress;
            _context6.next = 3;
            return http.post("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/questions/tfs"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _createTF.apply(this, arguments);
}

function createFIB(_x3) {
  return _createFIB.apply(this, arguments);
}

function _createFIB() {
  _createFIB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref3) {
    var courseTemplateId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            courseTemplateId = _ref3.courseTemplateId, data = _ref3.data, onUploadProgress = _ref3.onUploadProgress;
            _context7.next = 3;
            return http.post("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/questions/fibs"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _createFIB.apply(this, arguments);
}

function createEssay(_x4) {
  return _createEssay.apply(this, arguments);
}

function _createEssay() {
  _createEssay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref4) {
    var courseTemplateId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            courseTemplateId = _ref4.courseTemplateId, data = _ref4.data, onUploadProgress = _ref4.onUploadProgress;
            _context8.next = 3;
            return http.post("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/questions/essays"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _createEssay.apply(this, arguments);
}

function createOrdering(_x5) {
  return _createOrdering.apply(this, arguments);
}

function _createOrdering() {
  _createOrdering = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref5) {
    var courseTemplateId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            courseTemplateId = _ref5.courseTemplateId, data = _ref5.data, onUploadProgress = _ref5.onUploadProgress;
            _context9.next = 3;
            return http.post("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/questions/ordering"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _createOrdering.apply(this, arguments);
}

function createMatching(_x6) {
  return _createMatching.apply(this, arguments);
}

function _createMatching() {
  _createMatching = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref6) {
    var courseTemplateId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            courseTemplateId = _ref6.courseTemplateId, data = _ref6.data, onUploadProgress = _ref6.onUploadProgress;
            _context10.next = 3;
            return http.post("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/questions/matching"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _createMatching.apply(this, arguments);
}

function getQuestions(_x7) {
  return _getQuestions.apply(this, arguments);
}

function _getQuestions() {
  _getQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref7) {
    var courseTemplateId, params, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            courseTemplateId = _ref7.courseTemplateId, params = _ref7.params;
            _context11.next = 3;
            return http.get("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/questions"), {
              params: params
            });

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _getQuestions.apply(this, arguments);
}

var updateCourseTemplatesSkillCategories = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref8) {
    var courseTemplateId, skillCategoryIds, semesterId, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            courseTemplateId = _ref8.courseTemplateId, skillCategoryIds = _ref8.skillCategoryIds, semesterId = _ref8.semesterId;
            _context.next = 3;
            return http.patch("".concat(constants.API_URL_V1, "/course-templates/").concat(courseTemplateId, "/skill-categories"), {
              skillCategoryIds: skillCategoryIds,
              semesterId: semesterId
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateCourseTemplatesSkillCategories(_x8) {
    return _ref9.apply(this, arguments);
  };
}();

var createCourseTemplateSkills = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref10) {
    var courseTemplateId, data, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            courseTemplateId = _ref10.courseTemplateId, data = _ref10.data;
            _context2.next = 3;
            return http.post("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/course-template-skills"), data);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createCourseTemplateSkills(_x9) {
    return _ref11.apply(this, arguments);
  };
}();

var deleteCourseTemplateSkills = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref12) {
    var data, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            data = _ref12.data;
            _context3.next = 3;
            return http.post("".concat(constants.API_URL, "/course-template-skills/delete-bulk"), data);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteCourseTemplateSkills(_x10) {
    return _ref13.apply(this, arguments);
  };
}();

var updateCourseTemplateSkills = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref14) {
    var courseTemplateSkillId, data, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            courseTemplateSkillId = _ref14.courseTemplateSkillId, data = _ref14.data;
            _context4.next = 3;
            return http.patch("".concat(constants.API_URL, "/course-template-skills/").concat(courseTemplateSkillId), data);

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function updateCourseTemplateSkills(_x11) {
    return _ref15.apply(this, arguments);
  };
}();

function deleteCourseTemplate(_x12) {
  return _deleteCourseTemplate.apply(this, arguments);
}

function _deleteCourseTemplate() {
  _deleteCourseTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref16) {
    var courseTemplateId, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            courseTemplateId = _ref16.courseTemplateId;
            _context12.next = 3;
            return http["delete"]("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId));

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _deleteCourseTemplate.apply(this, arguments);
}

function editCertificateOptions(_x13) {
  return _editCertificateOptions.apply(this, arguments);
}

function _editCertificateOptions() {
  _editCertificateOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref17) {
    var courseTemplateId, certificateOptions, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            courseTemplateId = _ref17.courseTemplateId, certificateOptions = _ref17.certificateOptions;
            _context13.next = 3;
            return http.patch("".concat(constants.API_URL, "/course-templates/").concat(courseTemplateId, "/certificate-options"), certificateOptions);

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _editCertificateOptions.apply(this, arguments);
}

function upsertCourseTemplateAttendanceSettings(_x14) {
  return _upsertCourseTemplateAttendanceSettings.apply(this, arguments);
}

function _upsertCourseTemplateAttendanceSettings() {
  _upsertCourseTemplateAttendanceSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref18) {
    var data, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            data = _ref18.data;
            _context14.next = 3;
            return http.put("".concat(constants.API_URL, "/course-templates/course-template-attendance-settings"), data);

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _upsertCourseTemplateAttendanceSettings.apply(this, arguments);
}

export default {
  createMCQ: createMCQ,
  createTF: createTF,
  createFIB: createFIB,
  createEssay: createEssay,
  createOrdering: createOrdering,
  createMatching: createMatching,
  getQuestions: getQuestions,
  updateCourseTemplatesSkillCategories: updateCourseTemplatesSkillCategories,
  createCourseTemplateSkills: createCourseTemplateSkills,
  deleteCourseTemplateSkills: deleteCourseTemplateSkills,
  updateCourseTemplateSkills: updateCourseTemplateSkills,
  deleteCourseTemplate: deleteCourseTemplate,
  editCertificateOptions: editCertificateOptions,
  upsertCourseTemplateAttendanceSettings: upsertCourseTemplateAttendanceSettings
};